import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { compose, pick, prop } from 'ramda';
import { Loader } from '@core/js/components/common/Loader';
import { useSportsbookSelector, useAppSelector } from '@core/js/store/hooks';
import { WebContent } from '@core/js/components/system/WebContent';
import { withComponent } from '@core/js/components/hocs/withComponent';
import { useComponentConfig, useComponentMethods, useComponentTranslations } from '@core/js/hooks/component';
import { startIntegration } from '@core/js/components/system/App/hooks/useSportsbookIntegration/store/actions';

import * as hooks from '@core/js/components/main/SportsbookApp/hooks';
import * as constants from '@core/js/components/main/SportsbookApp/constants';
import { MetaTags } from '@core/js/components/main/SportsbookApp/components/MetaTags';

import style from '@core/js/components/main/SportsbookApp/SportsbookApp.scss';

export const SportsbookAppBare = () => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const { showComponentError, showComponentWc } = useComponentMethods(); /* Solverde changes */
    const { isAppInitError, isIntegrationScriptError } = useSportsbookSelector(pick(['isAppInitError', 'isIntegrationScriptError']));
    const isError = isIntegrationScriptError || isAppInitError;
    const { maintenanceWebContent } = useComponentConfig();
    const dynamicTags = useAppSelector(prop('dynamicTags')); /* Solverde changes */
    const webContentDescription = dynamicTags?.DTAG_SPORTSBOOK_ERROR_CONTENT; /* Solverde changes */

    useEffect(() => {
        if (isError && !maintenanceWebContent) { /* Solverde changes */
            if (webContentDescription) {
                showComponentWc(webContentDescription); /* Solverde changes */
            } else {
                showComponentError(translate('error.unavailable'));
            }
        }
    }, [
        isError,
        showComponentError,
        maintenanceWebContent,
        translate,
        showComponentWc,
        webContentDescription
    ]);

    useEffect(() => {
        dispatch(startIntegration());
    }, [dispatch]);

    hooks.useMountSportsbook();
    hooks.useUnmountSportsbook();
    hooks.useNavigateSportsbook();

    if (isError && maintenanceWebContent) {
        return <WebContent id={maintenanceWebContent} />;
    }

    return (
        <div className="cms-sportsbook-app">
            <MetaTags />
            <div id={constants.CONTAINER_ID}>
                <div className={style.loadingContainer}>
                    <Loader />
                </div>
            </div>
            <div id="sportsbook-modals" className={style.modals}>
                <div id={constants.SPORTS_OVERLAYS_ID} />
            </div>
        </div>
    );
};

export const SportsbookApp = compose(
    withComponent({
        tkPrefix: 'playtech.mobile.system.sportsbook.'
    })
)(SportsbookAppBare);

export default SportsbookApp;
